module.exports = __webpack_public_path__ + "static/media/17.0d878095.mp3";